// import { get } from "../../api";
import moment from 'moment';

// state
const state = {
  filters: false,
  loading: false,
  filter: {
    tokens: [],
  },
  dataPresent: true,
  filterOptions: {
    groups: {
      interfaces: [],
      areas: [],
      cities: [],
      adSchedules: [],
      active: [],
    },
    screens: {
      groups: [],
      ad_schedules: [],
      versions: [],
      session_status: [],
      network_status: [],
      trip_type: [],
      launch_mode: [],
      colors: [],
    },
    home: {
      groups: [],
      areas: [],
      cities: [],
    },
    devices: {
      groups: [],
      cities: [],
    },
    reconciliation: {
      oneWay: {
        confirmation: [],
        callStatus: [],
        tablets: [],
        contacts: [],
        rentalStatusType: [],
      },
      return: {
        confimation: [],
        callStatus: [],
        groups: [],
        rentalStatus: [],
        tripType: [],
        rentalStatusType: [],
        tablets: [],
      },
      confirmation: ['Confirmed', 'Not Confirmed'],
      callStatus: [],
      groups: [],
      rentalStatus: [],
      tripType: [],
      rentalStatusType: [],
      tablets: [],
    },
    reports: {
      group: [],
      areas: [],
      ad_schedule: [],
      city: [],
      status: [],
      tripType: [],
      overdue: [],
      color: [],
    },
    keys: {
      cities: [],
      used: [],
    },
  },
};

// getters
const getters = {
  getFilter(state) {
    return state.filter;
  },
  getFilters(state) {
    return state.filters;
  },
  getHomeFilterParamString(state) {
    let homeFilter = null;
    if (localStorage.filter) {
      homeFilter = JSON.parse(localStorage.filterParams);
    } else {
      homeFilter = state.filter;
    }
    const newFilter = { ...homeFilter };
    delete newFilter.range;
    delete newFilter.search;
    delete newFilter.searchType;
    delete newFilter.name;
    delete newFilter.filter;
    if (!newFilter.start_date) {
      newFilter.start_date = moment()
        .startOf('isoWeek')
        .format('YYYY-MM-DD');
    }
    if (!newFilter.end_date) {
      newFilter.end_date = moment()
        .endOf('isoWeek')
        .format('YYYY-MM-DD');
    }
    newFilter.start_date = moment(newFilter.start_date)
      .startOf('day')
      .format('YYYY-MM-DD');
    newFilter.end_date = moment(newFilter.end_date)
      .endOf('day')
      .format('YYYY-MM-DD');
    const filterParam = JSON.stringify(newFilter);
    const stringFilter = filterParam
      .replace(/"/g, '')
      .replace(/{/g, '')
      .replace(/}/g, '')
      .replace(/:/g, '=')
      .replace(/,/g, '&');
    const returnFilter = stringFilter
      .replace(newFilter.start_date, moment(newFilter.start_date).toISOString())
      .replace(newFilter.end_date, moment(newFilter.end_date).toISOString());
    return returnFilter;
  },
  getUsersFilter(state) {
    return state.filter.users;
  },
  getGroupsFilterOptions(state) {
    return state.filterOptions.groups;
  },
  getScreensFilterOptions(state) {
    return state.filterOptions.screens;
  },
  getReportsFilterOptions(state) {
    return state.filterOptions.reports;
  },
  getHomeFilterOptions(state) {
    return state.filterOptions.home;
  },
  getClearedFilterParams(state) {
    return state.clearedFilterParams;
  },
  getDevicesFilterOptions(state) {
    return state.filterOptions.devices;
  },
  getReconciliationFilterOptions(state) {
    return state.filterOptions.reconciliation;
  },
  getKeyFilterOptions(state) {
    return state.filterOptions.keys;
  },
  getDataPresent(state) {
    return state.dataPresent;
  },
};

// const route = '/filter';

// actions
const actions = {
  setFilter: async ({ commit }, payload) => {
    commit('setFilter', payload);
  },
  setToken: async ({ commit }, payload) => {
    await commit('setCurrentToken', payload);
  },
  // getFilterData: async ({ commit }, payload) => {
  //   return get(route, payload)
  //     .then(() => {
  //     })
  // }
};

// mutations
const mutations = {
  setFilter(state, payload) {
    state.filter = payload;
  },
  setFilters(state, payload) {
    state.filters = payload;
  },
  // setFilter(state, payload) {
  //   state.filterParams[payload.name] = payload.filter;
  // },
  setFilterParams(state, payload) {
    state.filterParams = payload;
  },
  setHomeFilter(state, payload) {
    state.filterParams.home = payload;
  },
  setScreensFilter(state, payload) {
    state.filterParams.screens = payload;
  },
  setGroupsFilter(state, payload) {
    state.filterParams.groups = payload;
  },
  setReconciliationFilter(state, payload) {
    state.filterParams.reconciliation = payload;
  },
  setReportsFilter(state, payload) {
    state.filterParams.reports = payload;
  },
  setGroupsFilterOptions(state, payload) {
    state.filterOptions.groups = payload;
  },
  setScreensFilterOptions(state, payload) {
    state.filterOptions.screens = payload;
  },
  setKeyFilterOptions(state, payload) {
    state.filterOptions.keys = payload;
  },
  setReportsFilterOptions(state, payload) {
    state.filterOptions.reports = payload;
  },
  setDevicesFilterOptions(state, payload) {
    state.filterOptions.devices = payload;
  },
  setCurrentToken(state, payload) {
    state.filter.tokens[state.filter.page + 1] = payload;
  },
  setPrevNextToken(state, payload) {
    state.filter.prevNextToken = payload;
  },
  setUpcomingNextToken(state, payload) {
    state.filter.upcomingNextToken = payload;
  },
  setPage(state, payload) {
    state.filter.page = payload;
  },
  setHomeFilterOptions(state, payload) {
    const groups = [];
    const cities = [];
    for (let i = 0; i < payload.length; i++) {
      groups.push({
        text: payload[i].group_name,
        value: payload[i].uuid,
      });
      if (payload[i].address) {
        cities.push(payload[i].address.city);
      }
    }
    state.filterOptions.home = {
      groups,
      cities,
    };
    state.filterOptions.devices = {
      groups,
      cities,
    };
  },
  setClearedFilterParams(state, payload) {
    state.clearedFilterParams = payload;
  },
  setReconciliationOneWayFilterOptions(state, payload) {
    state.filterOptions.reconciliation.oneWay = payload;
  },
  setReconciliationReturnFilterOptions(state, payload) {
    state.filterOptions.reconciliation.return = payload;
  },
  setDataPresent(state, payload) {
    state.dataPresent = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
